exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-title[data-v-748b2f8a]{font-size:1.35rem;color:rgba(0,0,0,.6)}.section-desc[data-v-748b2f8a]{font-size:.875rem;color:rgba(0,0,0,.6);margin-bottom:8px}.entry-label[data-v-748b2f8a]{font-size:.8rem;color:rgba(0,0,0,.45);margin-bottom:16px;letter-spacing:.01em}", ""]);

// exports
